import utils from '@/mixins/utils.js'

// Função para verificar pendências baseada nos alertas da TabelaCadastros.vue
function verificarPendencias(item) {
  const pendencias = []

  // Consultas (a_pb)
  if (item.a_pb == null || item.a_pb == 0) {
    pendencias.push('Consulta')
  }

  // Peso e altura (b_pb)
  if (item.b_pb == null || item.b_pb == 0) {
    pendencias.push('Peso e altura')
  }

  // Visitas (c_pb)
  if (item.c_pb == null || item.c_pb == 0) {
    pendencias.push('Visitas ACS/TACS')
  }

  // Vacinas (d_pb)
  if (item.d_pb == null || item.d_pb == 0) {
    pendencias.push('Vacina influenza')
  }

  return pendencias.length > 0 ? pendencias.join(', ') : ''
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      let idade = `${utils.methods.formatDate(item.dt_nascimento)} (${
        item.idade
      } ${item.idade > 1 ? 'anos' : 'ano'})`
      return idade
    },
  },
  Mãe: 'no_mae',
  'M.Área': 'micro_area',
  IVCF: {
    callback: (item) => {
      return item.ivcf_atual ?? ''
    },
  },
  Pendências: {
    callback: (item) => {
      return verificarPendencias(item)
    },
  },
}

export const infoHtml = ``
